export default "__VITE_ASSET__c28b5282__"